import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.userStore || initialState;

export const selectUserStore = createSelector([selectSlice], state => state);
